/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/control-has-associated-label */

import React, { useState, useContext } from 'react';
import { motion } from 'framer-motion';
import moment from 'moment';
import S3 from 'react-aws-s3';
// import UploadDocumentModal from './Modals/uploadDocumentsModal';
import { CamelCase, PriceHandler } from '../../redux/helper/CamelCase';
import { distributorService } from '../../service/distributor.service';
import { Uploadconfig } from '../../redux/helper/upload-config';
import HeaderContext from '../../Components/Context/HeaderContext';
import ViewandDownloadModal from '../Invoices/Modals/viewandDownloadModal';
// import UpdateInvoiceInformationModal from './Modals/updateInvoiceInformationModal';

function ReturnRequestListing({
    invoiceList, setinvoiceList, isEditId, setisEditId, sortType, setsortType, setApproveModal, setResponse, setSelectedInvoice,

}) {
    const {
        SetErrorMessage,
        setcolorValue,
    } = useContext(HeaderContext);
    const [viewInvoiceDetails, setViewInvoiceDetails] = useState({});
    const [viewandDownloadModal, setViewandDownloadModal] = useState(false);
    const current = JSON.parse(localStorage.getItem('user')).profile.roles;
    const handleViewInvoiceDetails = async (invoiceNumber) => {
        const res = await distributorService.ViewInvoicesDetails(invoiceNumber);
        if (!res.error && res.data.success_status) {
            setViewInvoiceDetails(res.data.data);
            setViewandDownloadModal(true);
        } else {
            SetErrorMessage(res.message.message);
            setcolorValue('red');
            setTimeout(() => {
                SetErrorMessage('');
                setcolorValue('');
            }, 2000);
        }
    };

    return (
        <div>
            <div
                className="overflow-auto dropdown-menu pb-7 z-10 sticky top-0 left-0"
                style={{ height: 'calc(100vh - 298px)' }}
            >
                <table className="w-full table-auto relative">
                    <thead className="sticky top-0 left-0 z-[2]">
                        <tr className="bg-[#555259] h-10">
                            <th className="py-[5px] px-6 rounded-bl-lg rounded-tl-lg min-w-[142px] sticky top-0 left-0 bg-[#555259]" scope="col">
                                <span className="text-sm29 font-bold text-[#FFFFFF]">
                                    Invoice No.
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[168px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    E-waybill No.
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[184px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Customer Code
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[184px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Customer Name
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[250px] text-center">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Invoice Date
                                    <a href="#" className="pl-[5px]">
                                        <motion.img
                                            animate={{ rotate: sortType === 'INVOICE_DATE+asc' ? 180 : 0 }}
                                            className={`${sortType === 'INVOICE_DATE+desc' ? 'image-rotate' : ''}`}
                                            src="/images/sort.svg"
                                            alt="icon"
                                            onClick={() => {
                                                if (sortType === 'INVOICE_DATE+asc') {
                                                    setsortType('INVOICE_DATE+desc');
                                                } else if (sortType === 'INVOICE_DATE+desc') {
                                                    setsortType('INVOICE_DATE+asc');
                                                } else {
                                                    setsortType('INVOICE_DATE+asc');
                                                }
                                            // setCurrentPage(1);
                                            // setisLoaded(true);
                                            }}
                                        />
                                    </a>
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[188px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Order Category
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Transporter Name
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[250px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Indent Number
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[250px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Order Date
                                    <a href="#" className="pl-[5px]">
                                        <motion.img
                                            animate={{ rotate: sortType === 'ORDER_DATE+asc' ? 180 : 0 }}
                                            className={`${sortType === 'ORDER_DATE+desc' ? 'image-rotate' : ''}`}
                                            src="/images/sort.svg"
                                            alt="icon"
                                            onClick={() => {
                                                if (sortType === 'ORDER_DATE+asc') {
                                                    setsortType('ORDER_DATE+desc');
                                                } else if (sortType === 'ORDER_DATE+desc') {
                                                    setsortType('ORDER_DATE+asc');
                                                } else {
                                                    setsortType('ORDER_DATE+asc');
                                                }
                                            // setCurrentPage(1);
                                            // setisLoaded(true);
                                            }}
                                        />
                                    </a>
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Order Acceptance No.
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[240px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Shipped From
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[240px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Shipped to
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[180px] pl-[15px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-end">
                                    Invoice Value
                                    <a href="#" className="pl-[5px]">
                                        <motion.img
                                            animate={{ rotate: sortType === 'INVOICE_VALUE+asc' ? 180 : 0 }}
                                            className={`${sortType === 'INVOICE_VALUE+desc' ? 'image-rotate' : ''}`}
                                            src="/images/sort.svg"
                                            alt="icon"
                                            onClick={() => {
                                                if (sortType === 'INVOICE_VALUE+asc') {
                                                    setsortType('INVOICE_VALUE+desc');
                                                } else if (sortType === 'INVOICE_VALUE+desc') {
                                                    setsortType('INVOICE_VALUE+asc');
                                                } else {
                                                    setsortType('INVOICE_VALUE+asc');
                                                }
                                            // setCurrentPage(1);
                                            // setisLoaded(true);
                                            }}
                                        />
                                    </a>
                                </span>
                            </th>
                            <th scope="col" className="py-[5px] px-7 min-w-[172px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center">
                                    Payment Status
                                </span>
                            </th>
                            <th scope="col" className="rounded-tr-lg rounded-br-lg sticky top-0 right-0 bg-[#555259] py-[5px] px-7 min-w-[66px]">
                                <span className="text-sm29 font-bold text-[#FFFFFF] flex items-center justify-center" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoiceList.length > 0 && invoiceList.map((invoice, i) => (
                            <tr className="bg-[#FFFFFF] border-b border-[#DFEAF7]">
                                <td
                                    className="text-sm font-normal text-[#090406] py-[5px] px-7 sticky left-0 flex justify-center items-center pt-4"
                                    style={{
                                        background: 'rgba(255, 255, 255, 0.45)',
                                        backdropFilter: 'blur(5.5px)',
                                    }}
                                >
                                    {invoice?.TRX_NUMBER}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.WAYBILL_NUMBER}
                                </td>
                                <td className="text-sm font-normal text-[#090406] text-center py-[5px] px-7">
                                    {invoice?.CUSTOMER_CODE}
                                </td>
                                <td className="text-sm font-normal text-[#090406] text-center py-[5px] px-7">
                                    {invoice?.CUST_ACCOUNT_NAME}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {moment(invoice?.INVOICE_DATE).format('DD-MMM-YYYY, HH:mm:ss')}
                                </td>
                                <td className="text-sm font-normal text-[#090406] text-center py-[5px] px-7">
                                    {invoice?.ORDER_CATEGORY}
                                </td>
                                <td className="text-sm font-normal more-lines text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.TRANSPORTER_NAME}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.INDENT_NUMBER}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {moment(invoice?.ORDER_DATE).format('DD-MMM-YYYY, HH:mm:ss')}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.ORDER_ACCEPTANCE_NUMBER}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.SHIP_FROM}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.SHIP_TO}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-end">
                                    {PriceHandler(invoice?.INVOICE_VALUE)}
                                </td>
                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                    {invoice?.PAYMENT_STATUS === null ? 'PENDING' : invoice?.PAYMENT_STATUS }
                                </td>
                                <td
                                    onClick={() => {
                                        if (isEditId === i) {
                                            setisEditId('');
                                        } else {
                                            setisEditId(i);
                                            setSelectedInvoice(invoice);
                                        }
                                    }}
                                    className="py-2.5 px-7 sticky right-0 bg-[#ffffffe6] z-[1]"
                                    style={{
                                        background: 'rgba(255, 255, 255, 0.45)',
                                        backdropFilter: 'blur(5.5px)',
                                    }}
                                >
                                    <button className="dropdown-toggle" type="button" id="dropdownMenuButton111" data-bs-toggle="dropdown" aria-expanded="false">
                                        <img src="/images/more-vertical.svg" alt="icon" className="cursor-pointer" />
                                    </button>
                                    {isEditId !== '' && (
                                        <ul className={`dropdown-menu min-w-[150px] absolute ${isEditId === i ? 'show' : 'hidden'} top-5 right-12 bg-[#FFFFFF] rounded-[10px] shadow-s2`} aria-labelledby="actionButton">
                                            <li
                                                className="inline-block dropdown-item w-full py-2"
                                                data-bs-toggle="modal"
                                                data-bs-target="#update-category"
                                                onClick={() => handleViewInvoiceDetails(invoice?.INVOICE_NO)}
                                            >
                                                <p className="text-sm font-normal text-[#000000] cursor-pointer text-center">
                                                    View
                                                </p>
                                            </li>
                                            {current === 'sales_head'
                                            && (
                                                <>
                                                    <li
                                                        className="inline-block dropdown-item w-full py-2"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#updateInvoice"
                                                        onClick={() => { setApproveModal(true); setResponse(2); }}
                                                    >
                                                        <p className="text-sm font-normal text-[#000000] cursor-pointer text-center">
                                                            Approve
                                                        </p>
                                                    </li>
                                                    <li
                                                        className="inline-block dropdown-item w-full py-2"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#uploadInvoice"
                                                        onClick={() => { setApproveModal(true); setResponse(3); }}
                                                    >
                                                        <p className="text-sm font-normal text-[#000000] cursor-pointer text-center">
                                                            Reject
                                                        </p>
                                                    </li>

                                                </>
                                            ) }
                                        </ul>
                                    )}
                                </td>
                            </tr>

                        ))}

                    </tbody>
                </table>
            </div>
            {viewandDownloadModal && (
                <ViewandDownloadModal
                    viewandDownloadModal={viewandDownloadModal}
                    setViewandDownloadModal={setViewandDownloadModal}
                    viewInvoiceDetails={viewInvoiceDetails}
                    setViewInvoiceDetails={setViewInvoiceDetails}
                />
            )}
        </div>

    );
}

export default ReturnRequestListing;
